export default __webpack_public_path__ + "static/media/close-bot.7ffd1538.svg";